import { Theme } from "@mui/material";

export const audioPlayerStyles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 0 20px 20px",
    overflow: "hidden",
    width: { xs: "250px", sm: "300px" },
    minWidth: { xs: "250px", sm: "300px" },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
    gap: "20px",
  },
  text: {
    fontWeight: 600,
    color: "#06B6D4",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  speedSelect: {
    width: "65px",
    fontSize: "0.75rem",
    borderRadius: "12px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#06B6D4",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#06B6D4",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#06B6D4",
    },
    "& .MuiSvgIcon-root": {
      color: "#06B6D4",
    },
    color: "#06B6D4",
  },
  audioControlsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  playButton: {
    mr: 1,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  waveSurferContainer: {
    flex: 1,
    overflow: "hidden",
  },
  timeDisplay: {
    display: "flex",
    justifyContent: "space-between",
    mt: "12px",
  },
  timeTextLeft: {
    color: theme.palette.audioPlayer.timeColor,
    minWidth: "40px",
    textAlign: "left",
    fontSize: "16px",
  },
  timeTextRight: {
    color: theme.palette.audioPlayer.timeColor,
    minWidth: "40px",
    textAlign: "right",
    fontSize: "16px",
  },
  labelsContainer: {
    display: "flex",
    flexDirection: "column",
  },
});
